import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {createPunch} from "../../../actions/punchList";
import {PunchListForm} from "./PunchListForm";
import {currentEffectiveUserId} from "../../../reducers/ui";

const PunchListNew = props => {
  const { projectid, onSubmit, onCancel, userid } = props;
  return <Card title='Punch List Item Details' className={'edit-view'}>
    <PunchListForm projectid={projectid} onCancel={onCancel} onSubmit={onSubmit} userid={userid}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => ({ projectid: props.match.params.id, userid: currentEffectiveUserId(state) }),
    (dispatch, props) => ({
      onSubmit: (item) => {
        return dispatch(createPunch(props.match.params.id, item, (punchListId) => props.history.push(`/projects/${props.match.params.id}/punch-list/${punchListId}`)));
      },
      onCancel: () => props.history.goBack()
    })
  )
)(PunchListNew);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchListNew.js